import clsx from "classnames";
import { Col, Row } from "react-bootstrap";
import { Banner } from "@/ui/Banner";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";

export const SimplePageBannerSection = ({ className, page }) => {
  const locale = useLocale();

  return (
    <Banner
      className={clsx(className, classes.banner)}
      title={<h1>{page[`title_${locale}`]}</h1>}
      image={{ path: `page.${page.url_slug}.banner.image`, src: "/assets/banners/default.webp" }}
      alt={<h1>{page[`title_${locale}`]}</h1>}
    >
      <Row>
        <Col xs={12} md={6}>
          <div
            className={classes.banner__description}
            dangerouslySetInnerHTML={{ __html: page[`description_${locale}`] }}
          />
        </Col>
      </Row>
    </Banner>
  );
};

SimplePageBannerSection.defaultProps = {
  className: "",
};
